import { Fragment, useEffect, useMemo, useState } from 'react';
import { Page } from '../theme/elements/Page';
import { Box, Divider, Stack, Typography, useTheme } from '@mui/material';
import { useAppDispatch, useAppSelector } from 'hooks/redux.hooks';
import { selectTranslations } from 'state/reducers/translation.reducers';
import { permissionEnums } from 'constants/permission.constants';
import { hasPermission } from 'components/AuthorizationComponent';
import { Link, useParams } from 'react-router-dom';
import _ from 'lodash';
import {
	DashboardCategories,
	DashboardCategoriesFetchDataMapping,
	DashboardCategoriesFetchDataDetailsMapping,
} from 'constants/balance.constants';
import { PageHeader } from 'sections/MainDashboard/categoriesPages/PageHeader';
import { PageTable } from 'sections/MainDashboard/categoriesPages/PageTable';
import { PageFilters } from 'sections/MainDashboard/categoriesPages/PageFilters';
import { fetchCategoryData, getAccountBalances } from 'services/balances.service';
import { pagesEnum } from 'constants/ui.constants';
import { PageInnerLink } from 'sections/MainDashboard/categoriesPages/PageInnerLInk';
import { FilterComponent } from 'sections/MainDashboard/FilterComponent';

export const MainDashboardByCategory = () => {
	const t = useAppSelector(selectTranslations);
	const dispatch = useAppDispatch();
	const theme = useTheme();
	const balancePermission = hasPermission([permissionEnums.DASHBOARD_BALANCES]);
	const { category, plan } = useParams();
	const [data, setData] = useState<any[]>([]);
	const [loading, setLoading] = useState<boolean>(false);
	const pagePrefix = 'page.dashboard.dashboardBalances.';
	const filters = useAppSelector((state) => state.dashboard.filters);

	useEffect(() => {
		//get all related data by category
		//if (_.has(DashboardCategoriesFetchDataMapping, category as DashboardCategories)) {
		const api = _.get(DashboardCategoriesFetchDataMapping, category as DashboardCategories);
		const isDetailed = _.get(DashboardCategoriesFetchDataDetailsMapping, category as DashboardCategories);
		if (api && !loading) {
			if (category === DashboardCategories.MONTHLY_SUBSCRIPTIONS_BY_CUSTOMERS && !plan) return;
			setLoading(true);
			const extraProps = plan ? { planName: plan } : {};
			dispatch(fetchCategoryData({ name: api, data: { ...extraProps, filters, isDetailed } }))
				.unwrap()
				.then((data) => {
					setLoading(false);
					if (data) {
						switch (category) {
							case DashboardCategories.CUSTOMER_BALANCES:
							case DashboardCategories.CUSTOMER_BALANCES_DETAIL_BY_CUSTOMERS:
								setData(data?.accountBalance);
								break;
							case DashboardCategories.PENDING_BALANCE:
								setData(data?.pendingBalance);
								break;
							case DashboardCategories.PAYMENT_FEES:
								setData(_.get(data, DashboardCategories.PAYMENT_FEES));
								break;
							case DashboardCategories.CONVERSION_FEES:
								setData(_.get(data, DashboardCategories.CONVERSION_FEES));
								break;
							case DashboardCategories.MONTHLY_SUBSCRIPTIONS:
								setData(_.get(data, DashboardCategories.MONTHLY_SUBSCRIPTIONS));
								break;
							case DashboardCategories.TOTAL_REVENUE:
								setData(
									data.totalRevenueByCompany.filter((company: any) => company.totalRevenue !== 0)
								);
								break;
							case DashboardCategories.MONTHLY_SUBSCRIPTIONS_BY_CUSTOMERS:
								setData(_.get(data, 'companyFeesForEachPlan'));
						}
					}
				})
				.catch(() => setLoading(false));
		}
	}, [filters, category]);

	const parent = useMemo(() => {
		if (category === DashboardCategories.CUSTOMER_BALANCES_DETAIL_BY_CUSTOMERS) {
			return DashboardCategories.CUSTOMER_BALANCES;
		}
		if (category === DashboardCategories.MONTHLY_SUBSCRIPTIONS_BY_CUSTOMERS) {
			return DashboardCategories.MONTHLY_SUBSCRIPTIONS;
		}
	}, [plan, category]);

	return (
		<Fragment>
			<Page title="">
				<>
					{category && _.values(DashboardCategories).includes(category as DashboardCategories) ? (
						<Stack gap={3}>
							<PageHeader category={category as DashboardCategories} parent={parent} />
							<FilterComponent />
							{/* <PageFilters
                category={category as DashboardCategories}
                total='₪12,000,000'
              /> */}
							<Divider
								orientation="horizontal"
								flexItem
								sx={{ borderBottom: 1, borderColor: theme.palette.root.divider }}
							/>

							<PageInnerLink category={category as DashboardCategories} />
							{!loading && <PageTable data={data} type={category as DashboardCategories} />}
						</Stack>
					) : (
						<Typography variant="pageTitle" display={'block'} marginTop={'50vh'} textAlign={'center'}>
							{t('label.page_not_found')}
						</Typography>
					)}
				</>
			</Page>
		</Fragment>
	);
};
